import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';

import { SetProductComponent } from './set-product.component';
import { ElasticSearchService } from "../../../core/services/elastic-search.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';

const routes: Routes = [
    {
        path     : 'set/:type',
        component: SetProductComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        BrowserModule,
        SharedModule,
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule
    ],
    declarations: [
        SetProductComponent,
    ],
    providers:[
        ElasticSearchService,
        AuthGuard,RoleGuard
    ]
    
})
export class SetProductModule
{
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/set-product/set-product.module.ts